<template>
  <div id="address_details">
    <group-card title="Current Address" icon="location_on" :loading="loading_search_land_title" :tooltipText="tooltipText">
      <template v-slot:actions v-if="index > 0">
        <md-checkbox v-model="is_same_as_applicant" @change="copyFromApplicant1()">Same as applicant 1</md-checkbox>
      </template>

      <div class="boxed-category veda-required">
        <edit-applicant-address-history
          v-model="applicant.addresses.current"
          duration ownership
          @change="notifyAddressUpdate(applicant.addresses.current)"
          :prefixLabel="prefixLabel"
        />
      </div>

      <div v-if="showLandTitle">
        <LandTitleSearchResult
          :land-title-fetch-results="applicant.addresses.land_title"
          :application-id="application.loan.id"
          :applicant-id="applicant.id"
        >
        </LandTitleSearchResult>
        <md-dialog-alert
          :md-active.sync="error_dialog.show"
          :md-title="error_dialog.title"
          :md-content="error_dialog.content" />
        <loading-icon-text-button
          class="md-primary md-sm"
          @click="search_land_title"
          icon="search"
          :loading="loading_search_land_title">
          Search Land Title
        </loading-icon-text-button>
      </div>

    </group-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import filters from '@/components/utils/filters';
import ValidatedInputs from '@/components/ValidatedInput';
import GroupCard from '@/components/Cards/GroupCard';
import GroupCardRow from '@/components/Cards/GroupCardRow';
import EditApplicantAddressHistory from './EditApplicantAddressHistory.vue';
import LandTitleSearchResult from '@/components/Search/LandTitleSearchResult';
import LoadingIconTextButton from "../LoadingIconTextButton";
import { isAddressRentLike } from "@/components/utils/validation";
import ConfirmDialog from "../Dialogs/ConfirmDialog";

export default {
  components: {
    LoadingIconTextButton,
    ...ValidatedInputs,
    GroupCard,
    GroupCardRow,
    EditApplicantAddressHistory,
    LandTitleSearchResult,
    isAddressRentLike,
  },
  data(){
    return {
      alertMessage: false,
      message: '',
      loading_search_land_title: false,
      error_dialog: {
        show: false,
        title: '',
        content: '',
      },
      is_same_as_applicant: false,
      tooltipText: '<li>Renting - Clients name is on the lease - Collect how much is paid do not capture again in expenses as collect in residential area of Zink</li>'+
                    '<li>Boarding - Living at the residence but name is not on the lease (living with Friends or Family)</li>'+
                    '<li>Owned - Property is owned outright, no money owing</li>'+
                    '<li>Mortgaged - Client has a mortgage and is repaying the mortgage this is captured in Liabilities with banking details and out going etc</li>',
    };
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    autoDurationMandationService: {
      default: null,
    },
    prefixLabel: {
      type: String,
      default: '',
    },
    index: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    // standard list of options from store
    ...mapGetters({
      options: 'options',
      application: 'application',
    }),

    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    applicant: {
      get(){ return this.value },
      set(applicant){ this.$emit('input', applicant) },
    },

    showLandTitle() {
      return !isAddressRentLike(this.applicant.addresses.current);
    }
  },
  methods: {
    // make all filters available as methods
    ...filters,

    notifyAddressUpdate(address=null){
      if(this.autoDurationMandationService){
        this.autoDurationMandationService.update(address);
      }
    },
    async search_land_title() {
      if (this.application?.applicants?.[0]?.addresses?.land_title.length > 0) {
        const res = await this.showNotification(
          "Confirm",
          "This will request a new land title search and will incur an additional charge. Continue?",
          "Confirm",
          "Cancel"
        );
        if (!res) {
          return;
        }
      }

      try {
        this.loading_search_land_title = true;
        let current_address_history = this.applicant.addresses.current;

        if (current_address_history == '' ||
          current_address_history == null ||
          current_address_history.address.street_number == '' ||
          current_address_history.address.street_name == '' ||
          current_address_history.address.state == '' ||
          current_address_history.address.post_code == ''
        ) {
          this.error_dialog.title = 'Failed to search Land Title';
          this.error_dialog.content = 'Address field has not been filling up properly';
          this.error_dialog.show = true;
          this.loading_search_land_title = false;
          return false;
        }

        // create or update application
        let newApplication = await this.$store.dispatch('save_application', this.application);

        // search by ppsr
        let result = await this.$store.dispatch(
          'request_land_title_by_current_address', {
            application: this.application,
            address_history: current_address_history,
            address: current_address_history.address,
            applicant: this.applicant.id,
          });

        // re-load application from server
        await this.$store.dispatch("load_application", this.application.loan.id);

        if (result != true) {
          this.error_dialog.title = 'Failed to search Land Title';
          this.error_dialog.content = `The following error occurred: ${result}`;
          this.error_dialog.show = true;
        }
      } catch (error) {
        console.error(error);
        return false;
      }

      this.loading_search_land_title = false;
    },
    async copyFromApplicant1() {
      if (this.is_same_as_applicant) {
        await this.$store.dispatch('copyFromApplicant1', { type: 'current_address', applicant_index: this.index });
      }
    },
    showNotification(title, message, confirmText, cancelText = null) {
      return this.$modal.show(ConfirmDialog, {
        title,
        message,
        confirmText,
        cancelText
      })
    },
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
  created(){
    if(this.autoDurationMandationService){

      this.auto_duration_mandation_service_source = new this.autoDurationMandationService.Source(
        this.applicant.addresses.current,
        (address) => address.duration,
        'none'
      );

      this.autoDurationMandationService.registerSource(this.auto_duration_mandation_service_source);
      this.autoDurationMandationService.update();
    }
  },
};
</script>

<style scoped>
</style>
